import { connect } from 'react-redux'

import CustomerPortal from './components'

import { getHasPermissionsToPerformFunctionality } from '../../../../../redux/selectors/permissions'

import {
  FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_OPERATE_AS_CUSTOMER_USER,
  FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_KEG_COLLECTION_REQUEST,
} from '../../../../../constants/permissions'

const mapStateToProps = state => {
  const shouldOperateAsCustomerUserFormBeDisabled = !getHasPermissionsToPerformFunctionality({
    state,
    functionalityStringOrPermissionsMap:
      FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_OPERATE_AS_CUSTOMER_USER,
    isThisAPermissionsCheckOfALoggedInEmployee: true,
  })
  const shouldKegCollectionRequestFormBeDisabled = !getHasPermissionsToPerformFunctionality({
    state,
    functionalityStringOrPermissionsMap:
      FUNCTIONALITY_THAT_NEEDS_PERMISSIONS_KEG_COLLECTION_REQUEST,
    isThisAPermissionsCheckOfALoggedInEmployee: true,
  })

  return {
    // Why Booleans? See CODE_COMMENTS_252
    shouldOperateAsCustomerUserFormBeDisabled: Boolean(shouldOperateAsCustomerUserFormBeDisabled),
    shouldKegCollectionRequestFormBeDisabled: Boolean(shouldKegCollectionRequestFormBeDisabled),
  }
}

export default connect(mapStateToProps)(CustomerPortal)
